import { render } from "./UserView.vue?vue&type=template&id=62fce828&scoped=true&ts=true"
import script from "./UserView.vue?vue&type=script&lang=ts"
export * from "./UserView.vue?vue&type=script&lang=ts"

import "./UserView.vue?vue&type=style&index=0&id=62fce828&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62fce828"]])

export default __exports__